import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote:
      "Waylio picks up specimens from our clinic twice a day. The drivers are punctual, gentle with the parcels, and every drop-off is followed by a text confirmation.",
    name: "Dr. Elena Vasquez",
    role: "Head Veterinarian",
    company: "Peachtree Animal Clinic",
    img: "https://images.pexels.com/photos/7468978/pexels-photo-7468978.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "Vet Clinic",
  },
  {
    quote:
      "For a lab, chain of custody is non-negotiable. Waylio's HIPAA and OSHA-trained drivers gave us a courier partner we trust with clinical samples every single week.",
    name: "Marcus Doyle",
    role: "Lab Operations Manager",
    company: "Atlas Bioanalytics",
    img: "https://images.pexels.com/photos/36741681/pexels-photo-36741681.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "Laboratory",
  },
  {
    quote:
      "A settlement had to be signed across town in under two hours. Waylio hand-carried the documents, sent a photo of the delivery, and saved my closing.",
    name: "Priya Whitmore",
    role: "Partner",
    company: "Whitmore & Bell, PLLC",
    img: "https://images.pexels.com/photos/8730998/pexels-photo-8730998.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "Private Documents",
  },
  {
    quote:
      "Our online orders spike every Friday and Waylio's driver is already at the door before we can call. Same driver, same time — it's like having our own in-house delivery team.",
    name: "Jordan Kim",
    role: "Owner",
    company: "Peach Row Goods",
    img: "https://images.pexels.com/photos/6169678/pexels-photo-6169678.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "Retail",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-paper py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-14">
          <div className="col-span-12 md:col-span-7">
            <div className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">
              In their words
            </div>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] text-forest tracking-tight">
              The people we <span className="italic font-light">deliver for</span>.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`col-span-12 md:col-span-6 lg:col-span-3 flex flex-col ${
                i === 1 ? "md:mt-8" : i === 2 ? "md:mt-14" : i === 3 ? "md:mt-4 lg:mt-20" : ""
              }`}
            >
              <div className="relative frame-hover">
                <img
                  src={t.img}
                  alt={`${t.company} — ${t.tag}`}
                  className="w-full h-[260px] md:h-[280px] object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-forest/10" />
                <div className="absolute top-3 left-3 bg-terracotta text-cream text-[10px] uppercase tracking-[0.3em] px-2 py-1">
                  {t.tag}
                </div>
              </div>
              <div className="mt-6">
                <Quote className="w-6 h-6 text-terracotta" strokeWidth={1.2} />
                <blockquote className="mt-3 font-serif text-lg md:text-xl text-forest leading-[1.3]">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-6 text-sm text-charcoal/70">
                  <span className="text-forest font-medium">{t.name}</span> — {t.role},{" "}
                  {t.company}
                </figcaption>
              </div>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
